import { withStyles } from '@material-ui/core/styles';
import CheckCircle from '@material-ui/icons/CheckCircle';

export default withStyles({
  root: {
    color: 'green',
  },
})(CheckCircle);
